import React from 'react'
import useFormatCurrency from '../../../yoello-lib/modules/localisation/useCurrency'

export function PriceInVenueCurrency({price}:{price:number}) {
  const {formatCurrency} = useFormatCurrency();
  return (
    <>
      {formatCurrency(price)}
    </>
  )
}
